import React from "react";
import { CheckCircle } from "react-feather";
import { translate } from "react-switch-lang";
import { Alert } from "reactstrap";

const Tips = (props) => {
  return (
    // <Alert color="light">
    //   <div className="d-flex align-items-center">
    //     <CheckCircle size={18} className="mr-2 mb-2" />
    //     <h4 className="alert-heading">{"Tips"}</h4>
    //   </div>
    //   {props.children}
    // </Alert>
    <ul className="tipsOnhover-dropdown">
      <li className="profile-nav onhover-dropdown p-0">
        <div className="media profile-media">
          <div className="media-body">
            <span>Tips</span>
            <p className="mb-0 font-roboto">
            <CheckCircle size={18} className="mr-2 mb-2" />
            </p>
          </div>
        </div>
        <ul className="profile-dropdown onhover-show-div">
          <li>
            <span>{props.children}</span>
          </li>
        </ul>
      </li>
    </ul>
  );
};

export default translate(Tips);
